// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"386":"admin-fr-i18n","880":"streaming-fr-i18n"}[chunkId] + "." + {"386":"03d5a641","880":"98bc49fd"}[chunkId] + ".css";
};